/**
 * Users Frontend JavaScript Entry Point
 * 
 * This file serves as the main entry point for the Users area JavaScript functionality.
 * It imports and initializes all necessary JavaScript modules and controllers.
 */

// Import images (so Vite processes them)
import '../users/images'

// Import main JavaScript libraries
import "@hotwired/turbo-rails"

// Import and initialize Stimulus controllers
import "../users/js/controllers"

// Import Bootstrap JavaScript components
import "bootstrap"

// Import Alertify for notifications
// import "alertifyjs"

console.log('Users frontend initialized')
